import { useState } from 'react';

import { SORT_OPTIONS } from 'constants/common';
import { getListSortOrder } from 'helper/dataGrid';
import { ArrowFilledDownIcon, ArrowFilledUpIcon, RadioCheckedIcon, RadioUncheckedIcon } from 'assets/icons';

export const useProjectFilter = (projects = [], selectedProjects = []) => {
  const [searchValue, setSearchValue] = useState('');
  const [projectIds, setProjectIds] = useState(selectedProjects);
  const [order, setOrder] = useState(SORT_OPTIONS.DESC);

  const filteredProjects = projects
    .filter(
      ({ projectName }) => !(searchValue.length > 2) || projectName.toLowerCase().includes(searchValue.toLowerCase()),
    )
    .map(({ id, projectName, status, launchDate }) => ({
      id,
      status,
      name: projectName,
      launchDate: new Date(launchDate).getTime(),
    }))
    .toSorted((a, b) => (order === SORT_OPTIONS.DESC ? b.launchDate - a.launchDate : a.launchDate - b.launchDate));

  const onSelectProject = (projectId) => {
    setProjectIds((prevState) =>
      prevState.includes(projectId) ? prevState.filter((id) => id !== projectId) : [...prevState, projectId],
    );
  };

  const onSelectAllProjects = () => {
    setProjectIds((prevState) => (prevState.length ? [] : filteredProjects.map(({ id }) => id)));
  };

  const onChangeSortOrder = () => {
    setOrder((prevState) => getListSortOrder(prevState));
  };

  const tableBarButtons = [
    {
      label: 'Select All',
      Icon:
        !!filteredProjects.length && projectIds.length === filteredProjects.length
          ? RadioCheckedIcon
          : RadioUncheckedIcon,
      onClick: onSelectAllProjects,
    },
    {
      label: 'Recent',
      Icon: order === SORT_OPTIONS.DESC ? ArrowFilledDownIcon : ArrowFilledUpIcon,
      onClick: onChangeSortOrder,
    },
  ];

  const resetProjectIds = () => {
    setProjectIds(selectedProjects);
  };

  return {
    projectIds,
    resetProjectIds,
    projectList: filteredProjects,
    tableBarButtons,
    searchValue,
    setSearchValue,
    onSelectProject,
  };
};
